import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const mainBackendURL = import.meta.env.VITE_SERVER_URL;
export const jackpotBackendURL = import.meta.env.VITE_SERVER_JACKPOT_URL;

export const jackpotApi = createApi({
  reducerPath: 'jackpotApi',
  baseQuery: fetchBaseQuery({
    baseUrl: jackpotBackendURL ?? mainBackendURL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as { persistValues: { userToken: string } };
      const token = state.persistValues.userToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Balance'],
  endpoints: () => ({}),
});
